import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { EMPADRONAMIENTO_MENU_HISTORIAL } from "../../../../utils/constants";
import moment from "moment";

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: '2-digit',
  minute: '2-digit'
};

export const TablaHistorialEmp = (props) => {
  var envios = props.idMenu === EMPADRONAMIENTO_MENU_HISTORIAL.ENVIOS;
  var solicitudMenu = props.idMenu === EMPADRONAMIENTO_MENU_HISTORIAL.SOLICITUD;
  var nosConecta = props.idMenu === EMPADRONAMIENTO_MENU_HISTORIAL.NOSCONECTA;
  
  return (
    <React.Fragment>
      {Array.isArray(props.datos) && props.datos?.length > 0 ? (
        <Table>
          <TableHead>
            <TableRow>
              {solicitudMenu && (
                <>
                  <TableCell>Fecha</TableCell>
                  <TableCell>Usuario</TableCell>
                  <TableCell>Estado Anterior</TableCell>
                  <TableCell>Estado Nuevo</TableCell>
                </>
              )}
              {envios && (
                <>
                  <TableCell>N° Pedido</TableCell>
                  <TableCell>Fecha Envio</TableCell>
                  <TableCell>Codigo </TableCell>
                  <TableCell>Mensaje</TableCell>
                </>)}
              {nosConecta && (
                <>
                  <TableCell>Fecha Envio</TableCell>
                  <TableCell>Respuesta</TableCell>
                  <TableCell>Archivo (Url) </TableCell>
                </>)}
            </TableRow>
          </TableHead>
          <TableBody>
            {props.datos.map((solicitud) => {
              return (
                <TableRow key={solicitudMenu ? solicitud?.idHistorico.toString() : (envios ? solicitud.idEnvioScienza.toString() : solicitud.id.toString()) }>
                  {solicitudMenu && (
                    <>
                      <TableCell>
                        {new Date(solicitud.fecha).toLocaleString(
                          "es",
                          optionsfecha
                        )}
                      </TableCell>
                      <TableCell>{solicitud?.usuario?.userName}</TableCell>
                      <TableCell style={{ color: "red", fontWeight: "bold" }}>
                        {solicitud.estadoAnterior?.descripcion}
                      </TableCell>
                      <TableCell style={{ color: "green", fontWeight: "bold" }}>
                        {solicitud.estadoNuevo?.descripcion}
                      </TableCell>
                    </>
                  )}
                  {envios && (
                    <>
                      <TableCell>{solicitud.nroPedidoCliente}</TableCell>
                      <TableCell>{moment(solicitud.xmlFechaEnvio).format("DD-MM-YYYY HH:mm")}</TableCell>
                      <TableCell style={{ color: `${solicitud.codigoResultado === "ERROR" ? 'red' : 'green'}` }}>{solicitud.codigoResultado}</TableCell>
                      <TableCell>{solicitud.mensajeResultado}</TableCell>
                    </>
                  )}
                  {nosConecta && (
                    <>
                      <TableCell>{moment(solicitud.fecha).format("DD-MM-YYYY HH:mm")}</TableCell>
                      <TableCell style={{ color: `${solicitud.respuesta.includes("ok") ? 'green'  : 'red'}` }}>{solicitud.respuesta}</TableCell>
                      <TableCell>{solicitud.urlImagen}</TableCell>
                    </>
                  )}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      ) : (
        <Typography style={{ fontStyle: "italic", fontSize: "1.1rem" }}>
          No hay datos
        </Typography>
      )}
    </React.Fragment>
  );
};
